import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import app from 'flarum/common/app';

export default class UserPointsHistoryPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    
    // 从路由参数获取用户名，然后获取用户ID
    this.username = m.route.param('username');
    this.userId = null;
    this.pointsHistory = [];
    this.loading = true;
    this.hasMore = false;
    this.loadingMore = false;
    
    this.loadUserAndPointsHistory();
  }

  loadUserAndPointsHistory() {
    // 使用Flarum的用户查找API
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/users',
      params: {
        filter: {
          q: this.username
        }
      }
    }).then(response => {
      if (response.data && response.data.length > 0) {
        const userData = response.data[0];
        this.userId = userData.id;
        // 检查数据是否有正确的类型字段
        if (userData.type) {
          this.user = app.store.pushObject(userData);
        } else {
          // 如果没有类型字段，手动添加
          userData.type = 'users';
          this.user = app.store.pushObject(userData);
        }
        this.loadPointsHistory();
      } else {
        console.error('User not found:', this.username);
        this.loading = false;
        m.redraw();
      }
    }).catch(error => {
      console.error('Error loading user:', error);
      this.loading = false;
      m.redraw();
    });
  }

  loadPointsHistory(offset = 0) {
    this.loading = offset === 0;
    
    return app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/users/' + this.userId + '/point-logs',
      params: {
        page: {
          offset,
          limit: 20
        }
      }
    }).then(response => {
      if (offset === 0) {
        this.pointsHistory = response.data;
      } else {
        this.pointsHistory = this.pointsHistory.concat(response.data);
      }
      
      this.hasMore = !!response.links && !!response.links.next;
      this.loading = false;
      this.loadingMore = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading points history:', error);
      this.loading = false;
      this.loadingMore = false;
      m.redraw();
    });
  }

  loadMore() {
    if (this.loadingMore || !this.hasMore) return;
    
    this.loadingMore = true;
    this.loadPointsHistory(this.pointsHistory.length);
  }

  className() {
    return 'UserPointsHistoryPage';
  }

  title() {
    if (this.user) {
      return app.translator.trans('tf-points.forum.points_history.title') + ' - ' + this.user.displayName();
    }
    return app.translator.trans('tf-points.forum.points_history.title');
  }

  view() {
    if (this.loading) {
      return (
        <div className="UserPointsHistoryPage">
          <div className="container">
            <LoadingIndicator />
          </div>
        </div>
      );
    }

    return (
      <div className="UserPointsHistoryPage">
        <div className="container">
          <div className="UserPointsHistoryPage-header">
            <h1>{app.translator.trans('tf-points.forum.points_history.title')}</h1>
            {this.user && (
              <p>{app.translator.trans('tf-points.forum.points_history.description')} - {this.user.displayName()}</p>
            )}
          </div>
          
          <div className="UserPointsHistoryPage-content">
            {this.pointsHistory.length > 0 ? (
              <div className="PointsHistoryList">
                <div className="PointsHistoryList-header">
                  <div className="PointsHistoryList-header-date">
                    {app.translator.trans('tf-points.forum.points_history.date')}
                  </div>
                  <div className="PointsHistoryList-header-reason">
                    {app.translator.trans('tf-points.forum.points_history.reason')}
                  </div>
                  <div className="PointsHistoryList-header-points">
                    {app.translator.trans('tf-points.forum.points_history.points')}
                  </div>
                </div>
                
                {this.pointsHistory.map((historyItem, index) => (
                  <div key={index} className="PointsHistoryList-item">
                    <div className="PointsHistoryList-item-date">
                      {new Date(historyItem.attributes.createdAt).toLocaleString()}
                    </div>
                    <div className="PointsHistoryList-item-reason">
                      {historyItem.attributes.description}
                    </div>
                    <div className={`PointsHistoryList-item-points ${historyItem.attributes.pointsChange > 0 ? 'positive' : 'negative'}`}>
                      {historyItem.attributes.pointsChange > 0 ? '+' : ''}{historyItem.attributes.pointsChange}
                    </div>
                  </div>
                ))}
                
                {this.hasMore && (
                  <div className="PointsHistoryList-loadMore">
                    <Button 
                      className="Button Button--primary"
                      onclick={this.loadMore.bind(this)}
                      loading={this.loadingMore}
                    >
                      {app.translator.trans('tf-points.forum.points_history.load_more')}
                    </Button>
                  </div>
                )}
              </div>
            ) : (
              <div className="PointsHistoryList-empty">
                <p>{app.translator.trans('tf-points.forum.points_history.empty')}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
